/**
 * Created by admin on 11/27/17.
 */
export const TYPE_CHAT = 'chat';
export const TYPE_PRIVATE_MSG = 'private-msg';
export const TYPE_GROUP_CHAT = 'groupchat';
export const TYPE_BROADCAST = 'broadcast';
export const TYPE_VIDEO = 'video';
export const TYPE_LIVE_STREAM = 'liveStream';
export const TYPE_NOTIFICATION = 'notification';
export const TYPE_HEART_MSG = 'heartMsg';
export const TYPE_SEND_MESSAGE = 'sendMessage';
